module.exports = __webpack_public_path__ + "img/carte-blanche.89f9d7c1.jpg";